export default __webpack_public_path__ + "static/media/small-highest.3cd05003.svg";